
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import ClassesHeroSection from './components/ClassesHeroSection';
import ClassesSection from './components/ClassesSection';

export default function Classes() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <ClassesHeroSection />
        <ClassesSection />
      </main>
      <Footer />
    </div>
  );
}
